import { gsap } from 'gsap'
import { SplitText } from 'gsap/SplitText'

gsap.registerPlugin(SplitText)

export class SplitTextInstance {
  constructor (element, type, delay) {
    this.wrapper = element
    this.element = element

    this.name = element.getAttribute('data-name')
    this.splitted = new SplitText(this.element, { type: this.name, linesClass: 'line-wrapper', wordsClass: 'word-wrapper', charsClass: 'char-wrapper' })
    this.elements = this.splitted.words.length > 0 ? this.splitted.words : this.splitted.lines

    this.elements.forEach((el, index) => {
      this.wrap(el, index)
    })
  }

  wrap (el, index) {
    const elInner = document.createElement('div')
    elInner.innerHTML = el.innerHTML
    el.innerText = ''
    el.style.clipPath = 'polygon(0px -30%, 100% -30%, 100% 100%, 0% 100%)'
    elInner.style.padding = '0 0.5vw'
    el.appendChild(elInner)
  }
}
